// Sign-in modal management

import { markSearchPerformed } from '../state/session.js';

// Global variable to store pending search query when sign-in is required
// This will be set from pre/legacy.js
let pendingSearchQuery = null;

// WCAG 2.1.2: store focus to restore when modal closes
let signInModalPreviousFocus = null;
let signInModalTrapHandler = null;

function getFocusableElements(container) {
    const selector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    return Array.from(container.querySelectorAll(selector)).filter(
        (el) => el.offsetParent !== null && !el.disabled
    );
}

function trapFocusSignIn(e, dialogEl) {
    if (e.key !== 'Tab') return;
    const focusable = getFocusableElements(dialogEl);
    if (focusable.length === 0) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey) {
        if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
        }
    } else {
        if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    }
}

export function setPendingSearchQuery(query) {
    pendingSearchQuery = query;
}

export function getPendingSearchQuery() {
    return pendingSearchQuery;
}

export function clearPendingSearchQuery() {
    pendingSearchQuery = null;
}

export function openSignInModal() {
    const modal = document.getElementById('signInModal');
    if (modal) {
        signInModalPreviousFocus = document.activeElement;
        modal.classList.remove('hidden');
        document.body.style.overflow = 'hidden';

        // Wire the modal sign-in button to the sidebar sign-in button (guaranteed working handler)
        const cognitoSignInBtn = document.getElementById('cognitoSignInBtn');
        const sidebarSignInBtn = document.getElementById('signinActionBtn');
        if (cognitoSignInBtn && sidebarSignInBtn) {
            cognitoSignInBtn.onclick = () => sidebarSignInBtn.click();
        }

        const dialogEl = modal.querySelector('.modal-content');
        if (dialogEl) {
            const focusable = getFocusableElements(dialogEl);
            if (focusable.length > 0) focusable[0].focus();
            signInModalTrapHandler = (e) => trapFocusSignIn(e, dialogEl);
            document.addEventListener('keydown', signInModalTrapHandler);
        }
    }
}

export function closeSignInModal() {
    const modal = document.getElementById('signInModal');
    if (modal) {
        const dialogEl = modal.querySelector('.modal-content');
        if (dialogEl && signInModalTrapHandler) {
            document.removeEventListener('keydown', signInModalTrapHandler);
            signInModalTrapHandler = null;
        }
        modal.classList.add('hidden');
        document.body.style.overflow = '';
        if (signInModalPreviousFocus && typeof signInModalPreviousFocus.focus === 'function') {
            signInModalPreviousFocus.focus();
            signInModalPreviousFocus = null;
        }

        // If there's a pending search query, execute it now (user chose not to sign in)
        if (pendingSearchQuery) {
            const query = pendingSearchQuery;
            pendingSearchQuery = null; // Clear the pending query
            sessionStorage.removeItem('bms_pending_search_query'); // Also clear from sessionStorage
            markSearchPerformed(); // Mark that search has been performed to avoid showing modal again

            // Set the query in the search input
            const searchInput = document.getElementById('searchInput');
            if (searchInput) {
                searchInput.value = query;
            }

            // Execute the search without authentication
            // handleSearch is called via window.bms.handleSearch
            if (window.bms && window.bms.handleSearch) {
                window.bms.handleSearch();
            }
        }
    }
}
